var exports = {
  "k": "xe564cbfb--4f4869--container",
};

module.exports = exports;
